import reactWrapper from "@harbor/elements/utils/react/wrapper";
import PropTypes from "prop-types";

import { useI18n } from "../../../../i18n/useI18n";

const [HbrMarkdown] =
    reactWrapper(["hbr-markdown", "hbr-checkbox", "hbr-checkbox-group", "hbr-textarea", "hbr-button"]);

const ExplainChat = ({ selectedThread }) => {
    const { tCommon } = useI18n('common');
    // This function is called when the chat icon is clicked
    // You can implement the logic to handle the chat input here
    return (
        <div>
            <div className="hbr-css__chat-messages">
                {selectedThread.map((thread, index) => (
                    <>
                        <div key={index}></div>

                        {/* User message */}
                        <hbr-chat-message variant="user">
                            <div className="hbr-css__layout-col-xs">
                                {/* Header */}
                                <div className="hbr-css__layout-row-xs">
                                    <hbr-icon static-colors size="26px" name="avatar-frame" />
                                    <div className="hbr-css__text-primary-md-semibold">{tCommon('explainWidgetChatUser')}</div>
                                </div>
                                {/* Content */}
                                <HbrMarkdown content={thread.query} />
                            </div>
                        </hbr-chat-message>

                        {/* Assistant message */}
                        <hbr-chat-message variant="assistant">
                            <div className="hbr-css__layout-col-xs">
                                {/* Header */}
                                <div className="hbr-css__layout-row-xs">
                                    <hbr-icon static-colors size="26px" name="lens-logo" />
                                    <div className="hbr-css__text-primary-md-semibold">
                                        {tCommon('explainWidget')}
                                    </div>
                                </div>
                                {/* Content */}
                                <HbrMarkdown content={thread.response} />

                                {/* Loading spinner if applicable */}
                                {thread.spinner && (
                                    <div className="hbr-css__layout-row-xs">
                                        <hbr-spinner size="small">
                                            <hbr-icon slot="icon" name="loader-gradient" static-colors />
                                        </hbr-spinner>
                                        <div className="hbr-css__text-ai-sm-bold">
                                            {tCommon('explainWidgetChatGenerating')}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </hbr-chat-message>
                    </>
                ))}
            </div>
        </div >
    );
}

export default ExplainChat;

ExplainChat.propTypes = {
    //add propTypes
    selectedThread: PropTypes.arrayOf(
        PropTypes.shape({
            query: PropTypes.string.isRequired,
            response: PropTypes.string.isRequired,
            showSpinner: PropTypes.bool,
            time: PropTypes.number,
        })
    ).isRequired,
};